import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import MAdapter from './MAdapter';
import { addMetricToObj, getShareMessage, urlFormatter, domainReplacement, guid } from '../utils/utils';
import { getWxPublicId, wxAuth } from '../utils/wxAuth';
import { jsticket } from '../utils/urls';
import { loadJS } from '../utils/WaitJsLoaded';

var WechatMPAdapter = /*#__PURE__*/function (_MAdapter) {
  _inherits(WechatMPAdapter, _MAdapter);

  var _super = _createSuper(WechatMPAdapter);

  function WechatMPAdapter() {
    var _this;

    _classCallCheck(this, WechatMPAdapter);

    var callbackName = 'wxMPJsCallback' + guid();

    window[callbackName] = function (data) {
      var respData = data.respData;
      _this.jsticket = respData || {};
    };

    var wxPublicId = getWxPublicId({
      isWa: true
    });
    _this = _super.call(this, ['https://s1.zhuanstatic.com/common/jweixin-1.5.0.js', jsticket(wxPublicId, callbackName), 'https://s1.zhuanstatic.com/common/zzwa/static/js/zzwasdk-v1.4.35.js'], function () {
      var conf = _this.jsticket || {};
      wxAuth(conf);
      _this.zzwa = window.zzwa;
      _this.__sdk = _this.zzwa; // WASDK初始化依赖jweixin
      // 由于WASDK是外链，部分魔方页会引用两个adapter，需兼容新adpater调老sdk的情况

      if (_this.__sdk.init) _this.__sdk.init();
    });
    _this.wxPublicId = wxPublicId;
    return _this;
  }

  _createClass(WechatMPAdapter, [{
    key: "initWxConfig",
    value: function initWxConfig(cb) {
      var callbackName = 'wxMPJsCallback' + guid();
      loadJS(jsticket(this.wxPublicId, callbackName));

      window[callbackName] = function (data) {
        var respData = data.respData;
        var conf = respData || {};
        wxAuth(conf);
        window.wx.ready(function () {
          cb && cb();
        });
      };
    }
  }, {
    key: "asyncIn",
    value: function asyncIn(channel) {
      var cbsucss = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var cbfail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      typeof channel === 'string' && (channel = [channel]); // 兼容之前 微信和小程序区分不开的时候。

      if (~channel.indexOf('wa')) return cbsucss();
      return _get(_getPrototypeOf(WechatMPAdapter.prototype), "asyncIn", this).call(this, channel, cbsucss, cbfail);
    }
  }, {
    key: "share",
    value: function share() {
      this.zzwa.share(getShareMessage.apply(void 0, arguments));
    }
  }, {
    key: "skipToDetail",
    value: function skipToDetail() {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var newObj = addMetricToObj(args[0]);
      var newArgs = Object.assign([], args, [Object.assign({}, args[0], newObj)]);
      this.agentSkipToDetail(newObj, function () {
        var _this2$zzwa;

        (_this2$zzwa = _this2.zzwa).skipToDetail.apply(_this2$zzwa, _toConsumableArray(newArgs));
      });
    }
  }, {
    key: "skipToOrder",
    value: function skipToOrder() {
      var _this$zzwa;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var newObj = addMetricToObj(args[0]);
      var newArgs = Object.assign([], args, [Object.assign({}, args[0], newObj)]);

      (_this$zzwa = this.zzwa).skipToOrder.apply(_this$zzwa, _toConsumableArray(newArgs));
    }
  }, {
    key: "skipToUrl",
    value: function skipToUrl() {
      var _this$zzwa2;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      var targetUrl = args[0].targetUrl;
      targetUrl = urlFormatter(domainReplacement(targetUrl));
      var formatterArgs = Object.assign([], args, [Object.assign({}, args[0], {
        targetUrl: targetUrl
      })]);

      (_this$zzwa2 = this.zzwa).skipToUrl.apply(_this$zzwa2, _toConsumableArray(formatterArgs));
    }
  }, {
    key: "setTitle",
    value: function setTitle() {
      var _this$zzwa3;

      (_this$zzwa3 = this.zzwa).setTitle.apply(_this$zzwa3, arguments);
    }
  }, {
    key: "skipToSearchResult",
    value: function skipToSearchResult() {
      var _this$zzwa4;

      (_this$zzwa4 = this.zzwa).skipToSearchResult.apply(_this$zzwa4, arguments);
    }
  }, {
    key: "close",
    value: function close() {
      this.zzwa.close();
    }
  }, {
    key: "editPublish",
    value: function editPublish() {
      var _this$zzwa5;

      (_this$zzwa5 = this.zzwa).editPublish.apply(_this$zzwa5, arguments);
    }
  }, {
    key: "enterPublish",
    value: function enterPublish() {
      var _this$zzwa6;

      (_this$zzwa6 = this.zzwa).enterPublish.apply(_this$zzwa6, arguments);
    }
  }, {
    key: "enterChat",
    value: function enterChat() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      if (args[0].useWebIMInMP) {
        var _MAdapter$prototype$e;

        (_MAdapter$prototype$e = MAdapter.prototype.enterChat).call.apply(_MAdapter$prototype$e, [this].concat(args));
      } else {
        var _this$zzwa7;

        (_this$zzwa7 = this.zzwa).enterChat.apply(_this$zzwa7, args);
      }
    }
  }, {
    key: "enterHome",
    value: function enterHome() {
      var _this$zzwa8;

      (_this$zzwa8 = this.zzwa).enterHome.apply(_this$zzwa8, arguments);
    }
  }, {
    key: "enterOrderDetail",
    value: function enterOrderDetail() {
      var _this$zzwa9;

      (_this$zzwa9 = this.zzwa).enterOrderDetail.apply(_this$zzwa9, arguments);
    }
  }, {
    key: "enterProfile",
    value: function enterProfile() {
      var _this$zzwa10;

      (_this$zzwa10 = this.zzwa).enterProfile.apply(_this$zzwa10, arguments);
    }
  }, {
    key: "deliverSelectedParamInfoToPublish",
    value: function deliverSelectedParamInfoToPublish() {
      var _this$zzwa11;

      (_this$zzwa11 = this.zzwa).deliverSelectedParamInfoToPublish.apply(_this$zzwa11, arguments);
    }
  }, {
    key: "login",
    value: function login() {
      var _this$zzwa12;

      (_this$zzwa12 = this.zzwa).login.apply(_this$zzwa12, arguments);
    }
  }, {
    key: "getQRCodeScan",
    value: function getQRCodeScan() {
      var _this$zzwa13;

      (_this$zzwa13 = this.zzwa).getQRCodeScan.apply(_this$zzwa13, arguments);
    }
  }, {
    key: "postMessage",
    value: function postMessage() {
      var _this$zzwa14;

      (_this$zzwa14 = this.zzwa).postMessage.apply(_this$zzwa14, arguments);
    }
  }, {
    key: "getMarkLocation",
    value: function getMarkLocation(params) {
      window.wx.openLocation({
        latitude: params.lat,
        // 纬度，浮点数，范围为90 ~ -90
        longitude: params.lon,
        // 经度，浮点数，范围为180 ~ -180。
        name: params.name,
        // 位置名
        address: params.address,
        // 地址详情说明
        scale: 20 // 地图缩放级别,整形值,范围从1~28。默认为最大

      });
    }
  }, {
    key: "uploadPhotos",
    value: function uploadPhotos() {
      var _this$zzwa15;

      (_this$zzwa15 = this.zzwa).uploadPhotos.apply(_this$zzwa15, arguments);
    }
  }, {
    key: "enterUnifiedUrl",
    value: function enterUnifiedUrl() {
      var _this$zzwa16;

      (_this$zzwa16 = this.zzwa).enterUnifiedUrl.apply(_this$zzwa16, arguments);
    }
  }, {
    key: "registerPageCallback",
    value: function registerPageCallback(callback) {
      if (_typeof(callback) === 'object') {
        callback = callback.callback;
      }

      this.zzwa.onShow(function () {
        callback && callback({
          code: '0',
          msg: '页面显示',
          pageState: '1',
          result: ""
        });
      });
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(callback) {
      window.wx && wx.ready(function () {
        wx.getLocation({
          type: 'gcj02',
          complete: function complete(res) {
            if (res.errMsg.indexOf('ok') !== -1) {
              callback({
                code: "0",
                lon: res.longitude,
                lat: res.latitude
              });
            } else {
              callback({
                code: '-1'
              });
            }
          }
        });
      });
    }
  }, {
    key: "enlargeImage",
    value: function enlargeImage(obj) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var urls = obj.imgUrls.split('|');
      var current = urls[obj.selectedIndex];
      wx.previewImage({
        urls: urls,
        current: current,
        complete: function complete(res) {
          return callback(res);
        }
      });
    }
  }], [{
    key: "invalidMethodTip",
    value: function invalidMethodTip(method) {
      console.warn("\u8BE5\u7AEF\u672A\u5B9E\u73B0".concat(method, "\u65B9\u6CD5\uFF0C\u8BF7\u786E\u8BA4"));
    }
  }]);

  return WechatMPAdapter;
}(MAdapter);

export { WechatMPAdapter as default };